export const WowBoiLogo = () => {
    return (
        <div className="absolute bottom-7 left-0 right-0">
            <p className="text text-center text-lg">
            WowBoi™
                <span className="ml-2 text-red">
                    C
                </span>
                <span className="text-blue-dark">
                    o
                </span>
                <span className="text-green-dark">
                    l
                </span>
                <span className="text-pink">
                    o
                </span>
                <span className="text-yellow">
                    r
                </span>
            </p>
        </div>
    )
}